"use client";
import { Box, Image } from '@chakra-ui/react';
import { RenderStructuredText } from '@components/UI/Common/SectionCommonUI';
import SimpleButton from './SimpleButton';

export const TabContent = ({ title, content }) => {
    // const isMobile = useMediaQuery({ maxWidth: 767 });
    return (
        <>
            <Box
                display="flex"
                flexDirection={{ base: "column", sm: "column", md: "row" }}
                marginBottom={{ base: "29px", sm: "29px", md: "0" }}
            >
                <Box marginRight={{ md: "46px" }}>
                    <Image
                        display={{ sm: "flex" }}
                        flexDirection={"column"}
                        justifyContent={"center"}
                        alignItems={"center"}
                        width={{ md: "338px" }}
                        height={{ md: "322px" }}
                        src={content[0]?.image?.url || content[0]?.mobileImage?.url}
                    />
                    <Box display="flex" marginTop={"30px"} marginLeft={{ sm: "15px", base: "15px", md: "0px" }}>
                        {content[3]?.images?.map((el, index) => (
                            <Image
                                key={index}
                                src={el?.url}
                                height={{ sm: "31px", base: "31px", lg: "56px" }}
                                marginRight={"20px"}
                            />
                        ))}
                    </Box>
                </Box>
                <Box
                    width={{ base: "300px", sm: "300px", lg: "500px" }}
                    backkground={"red"}
                >
                    <Box
                        marginTop={{ sm: "20px", base: "20px", md: "0px" }}
                        color="#000"
                        fontSize={{ base: "20px", sm: "20px", lg: "32px" }}
                        fontWeight="semibold"
                        marginLeft={{ sm: "15px", base: "15px", lg: "12px" }}
                    >
                        {title}
                    </Box>

                    <Box className="project-detail">
                        <RenderStructuredText
                            sectionContent={content[1]}
                        />
                    </Box>

                    <Box
                        marginBottom={{ sm: "35px", base: "35px", lg: "0px" }}
                        marginLeft={{ sm: "15px", base: "15px", lg: "15px" }}
                    >
                        <SimpleButton
                            style={content[2]}
                            mb="0px"
                            targetwindow="_blank"
                        />
                    </Box>
                </Box>
            </Box >
            <style>
                {
                    `


        .project-detail .content-area ul  li {
            font-family: 'FedraSansStd-book';   
            font-size: 16px;
            margin-bottom: -20px;
           margin-left: -12px;
        whitespace: nowrap;
        }

    
        `

                }
            </style>


        </>
    )
};
